/**
 * Emission Factors READ endpoints — wire types for the two index tiers plus
 * the two bounded metadata reads that feed the settings area.
 *
 * All four routes are plain RLS-scoped reads: the Hono handlers query through
 * the per-request user client, and because BOTH views are `security_invoker`
 * the four base-table SELECT policies apply unchanged. DUAL SCOPE IS NOT
 * SCOPED IN THE VIEWS (`organization_id NULL` = a GLOBAL row shared by every
 * org): the endpoint applies
 * `.or('organization_id.is.null,organization_id.eq.<orgId>')` and RLS is the
 * backstop — see the migration's note 1
 * (`supabase/migrations/20260909184034_emission_factor_index_views.sql`).
 *
 * TWO TIERS:
 *  - `emission_factor_table_index` is BOUNDED (~10 rows per org) and read with
 *    a single `.limit(1000)` select. It is the first index view that is a
 *    ROLLUP — the counts the old grid could not show are computed in SQL.
 *  - `emission_factor_index` is KEYSET-paged by `?tableId=` on
 *    `(created_at DESC, id DESC)`, replacing a bare `select('*')` with no
 *    limit that was silently truncated at PostgREST's 1,000 rows.
 *
 * Shared by the API handlers (response construction) and the web index hooks
 * (unwrap target) so the two cannot drift. Template: `timesheetsReads.ts`.
 */
import { z } from "zod";
// ---------------------------------------------------------------------------
// Tier 2 (keyset): the FACTORS index, scoped by ?tableId=
// ---------------------------------------------------------------------------
/**
 * Query params for GET /orgs/:orgId/factors/index.
 *
 * Unlike the sibling index endpoints — which return the COMPLETE org index and
 * carry no params at all — this one is scoped to ONE table, because the
 * Factors grid only ever lives inside a table's detail page and an org-wide
 * factor walk would be tens of thousands of rows. `tableId` is REQUIRED and
 * must be a uuid: the handler rejects anything else with a 400 before it
 * touches the view, and separately 404s a table the caller cannot see.
 */
export const emissionFactorIndexQuerySchema = z.object({
    tableId: z.string().uuid(),
});
//# sourceMappingURL=emissionFactorReads.js.map